import TextureOutlinedIcon from '@mui/icons-material/TextureOutlined';

/**
 * Grau de celulite: aspecto da pele em graus de 1 a 4.
 * Referência clínica: classificação de Nürnberger e Müller (avaliação em pé,
 * deitado e com teste de compressão), na forma em quatro graus usada na
 * fisioterapia dermatofuncional no Brasil. Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/cellulite.php.
 */
const cellulite = {
  key: 'cellulite',
  name: 'Grau de celulite',
  description: 'Aspecto da celulite, do grau 1 ao 4',
  details: 'Classifica a celulite pelo aspecto da pele, do grau 1 (aparece só ao comprimir a pele) ao 4 (furinhos profundos, nódulos e flacidez). A avaliação é feita com o paciente em pé, músculos relaxados, e com leve compressão da pele quando nada aparece. Ajuda a planejar o tratamento e a mostrar a evolução. Um clique marca o grau do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: TextureOutlinedIcon,
  accent: 'pink',
  options: [
    { value: '1', label: 'Grau 1', caption: 'Só à compressão', image: 'celulite-1.png', help: 'Pele lisa em pé e deitado. As ondulações aparecem apenas ao comprimir a pele com os dedos.' },
    { value: '2', label: 'Grau 2', caption: 'Visível em pé', image: 'celulite-2.png', help: 'Ondulações leves visíveis em pé, sem compressão. Deitado, a pele tende a ficar lisa.' },
    { value: '3', label: 'Grau 3', caption: 'Furinhos evidentes', image: 'celulite-3.png', help: 'Furinhos e ondulações evidentes em pé e também deitado, aspecto de casca de laranja.' },
    { value: '4', label: 'Grau 4', caption: 'Nódulos e flacidez', image: 'celulite-4.png', help: 'Furinhos profundos, nódulos palpáveis e flacidez evidente, às vezes com sensibilidade ao toque.' },
  ],
};

export default cellulite;
